// extracted by mini-css-extract-plugin
export default {"marginBottom":"styles_marginBottom__N0hYU","tabs":"styles_tabs__JrfH1","selectedTab":"styles_selectedTab__QkkUX"};